
<div>
  <title id="location-table-title">Locations Data
    <loader class="loader" size="medium" *ngIf="data.length == 0"></loader>
  </title>

  <mat-form-field appearance="fill" id="location-metric-selection">
    <mat-label>Select Metric</mat-label>
    <mat-select (selectionChange)="onMetricSelect($event)">
      <mat-option [value]="'racks-per-day'">Racks Per Day</mat-option>
      <mat-option [value]="'rinse-additive'">Rinse Additive</mat-option>
      <mat-option [value]="'rinse-temp'">Rinse Temperature</mat-option>
      <mat-option [value]="'sanitizer'">Sanitizer</mat-option>
      <mat-option [value]="'wash-tank-changeout'">Wash Tank Changeout</mat-option>
      <mat-option [value]="'wash-temp'">Wash Temperature</mat-option>
    </mat-select>
  </mat-form-field>
</div>



<div class="table-container" id="location-table">
  <table class="box-shadow">
      <tr class="table-header">
        <th>Agreement Num</th>
        <th>Agreement Name</th>
        <th>Account Number</th>
        <th>Unit Number</th>
        <th>Account Name</th>
        <th>Address</th>
        <th *ngFor="let date of dateColumns"> {{ date }}</th>
      </tr>
      <tr *ngFor="let record of formattedData">
        <td>{{ record.agreementNumber }}</td>
        <td>{{ record.agreementName }}</td>
        <td>{{ record.accountNumber }}</td>
        <td>{{ record.unitNumber }}</td>
        <td>{{ record.accountName }}</td>
        <td>{{ record.address }}</td>
        <td *ngFor="let dateValue of record.dates">
          {{ dateValue }}
        </td>
      </tr>
  </table>
</div>
